import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import TournamentManager from './TournamentManager';
import { Event } from '../types/Event';

interface Props {
  event: Event;
  onClose: () => void;
  onEventUpdated: (updatedEvent: Event) => void;
  siteName: string;
  readOnly?: boolean;
}

const TournamentModalView: React.FC<Props> = ({ event, onClose, onEventUpdated, siteName, readOnly = false }) => {
  return (
    <Dialog
      open={true}
      onClose={onClose}
      fullScreen
      disableScrollLock={false}
    >
      <DialogTitle sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6">{readOnly ? '比賽詳情' : '比賽管理'} - {siteName}</Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0 }}>
        <Box sx={{ p: 2 }}>
          <TournamentManager 
            event={event} 
            onEventUpdated={onEventUpdated}
            readOnly={readOnly}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default TournamentModalView;

